
import { useQuery } from "convex/react";
import { api } from "../../api";

interface SelectedApp {
  id: string; // Added id field
  bundleId: string;
  appName: string;
  iconUrl?: string;
  trackId?: number | null;
}

export const useAppCatalogSearch = (searchQuery: string) => {
  const appsData = useQuery(api.apps.list.all, 
    searchQuery && searchQuery.length >= 2 ? {
      query: searchQuery,
      paginationOpts: {
        cursor: null,
        numItems: 10
      }
    } : "skip"
  );

  const transformedData = appsData?.page?.map((app: any) => ({
    id: app.id, // Use the new app.id field
    bundleId: app.bundleId,
    appName: app.name,
    iconUrl: app.iconUrl,
    trackId: null // Convex apps don't have trackId
  })) || [];

  return {
    data: transformedData,
    isLoading: appsData === undefined && searchQuery.length >= 2,
    error: null
  };
};
